import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { Observable } from 'rxjs';

import { ICoreConfigInternal } from '@core/core.config.model';

@Injectable()
export class ExternalAddressService {
    private apiUrl: string;

    constructor(
        @Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal,
        private http: HttpClient,
    ) {
        this.apiUrl = `${ config.apiEndpoint }api/external-address`;
    }

    public getTermPrivacyUrl(): Observable<string> {
        return this.http.get<string>(`${ this.apiUrl }/terms-privacy`);
    }
}
